import { AnyAction } from 'redux'
import { connect, ConnectedProps } from 'react-redux'
import { produce } from 'immer'
import { RootState } from '../../store'
import { ProgressBarProps } from './ProgressBar'

interface ProgressBarState {
  progress: number
  active: number
}

export type ProgressBarStateProps = ConnectedProps<typeof connector>

const initialState: ProgressBarState = {
  progress: 0,
  active: 0
}

export const actions = {
  add: 'progressBar/add',
  increment: 'progressBar/increment',
  setProgress: 'progressBar/setProgress',
  remove: 'progressBar/remove'
}

export default function reducers (state = initialState, action: AnyAction) {
  switch (action.type) {
    case actions.add:
      return produce(state, draft => {
        draft.active = draft.active + 1
      })
    case actions.increment:
      return produce(state, draft => {
        if (draft.progress < 100) {
          draft.progress = draft.progress + 1
        }
      })
    case actions.setProgress:
      return produce(state, draft => {
        draft.progress = action.progress
      })
    case actions.remove:
      return produce(state, draft => {
        if (draft.active > 0) {
          draft.active = draft.active - 1
        }
      })
    default:
      return state
  }
}

export const mapDispatchToProps = {
  add () {
    return { type: actions.add }
  },
  increment () {
    return { type: actions.increment }
  },
  setProgress (progress: number) {
    return { type: actions.setProgress, progress }
  },
  remove () {
    return { type: actions.remove }
  }
}

export function mapStateToProps (state: RootState, props?: ProgressBarProps) {
  return produce(state.progressBar, draft => draft)
}

export const connector = connect(mapStateToProps, mapDispatchToProps)
